import { Link } from 'react-router-dom'
import Translation from '../Translation/cont/Translation'

const ButtonLink = ({pathname, className, spanClassName, transId, text, hideText = true, disabled = false, outOfRouting=false, target="_self"}) => {
    const extraSpanClass = spanClassName ? ' ' + spanClassName : ''
    const spanClass = hideText ? "screen-reader-text" : "text" + extraSpanClass
    const innerSpan = <span className={spanClass}><Translation id={transId}>{text}</Translation></span>
    const encodedURI = encodeURI(pathname)

    if(disabled) {
        return <span className={'button ' + className}>{innerSpan}</span>
    } else if(outOfRouting) {
        return <a href={encodedURI} className={'button ' + className} target={target}>{innerSpan}</a>
    } else {
        return <Link to={{pathname: encodedURI}} className={'button ' + className}>{innerSpan}</Link>
    }
}

export default ButtonLink